import Client from "@stelar/api-sdk";

import { getEnvironmentValues } from "@/config/environment";

const { apiUrl, appVersion } = getEnvironmentValues();

export const client = new Client({
  apiUrl,
  xRequestedFor: "web-app",
  xRequestedVersion: appVersion,
});
